/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * GridHead CSS
 */
export const styles = css`
  :host([sticky]) {
    position: sticky;
    z-index: 2;
    top: 0;
  }

  @supports (-webkit-hyphens: none) {
    :host([sticky]) {
      display: block;
    }
  }
`;

export default [styles];
